module.exports = __webpack_public_path__ + "static/media/laksa_betawi.aa20ce2c.jpg";